import { render, staticRenderFns } from "./SpringSpinner.vue?vue&type=template&id=b316b56c&scoped=true&"
import script from "./SpringSpinner.vue?vue&type=script&lang=js&"
export * from "./SpringSpinner.vue?vue&type=script&lang=js&"
import style0 from "./SpringSpinner.vue?vue&type=style&index=0&id=b316b56c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b316b56c",
  null
  
)

export default component.exports